import { CreditCard } from "lucide-react";

export default function CockpitAbonnements() {
  return (
    <div className="mx-auto max-w-2xl rounded-lg border border-dashed border-slate-700 bg-slate-800/30 p-10 text-center">
      <CreditCard className="mx-auto h-12 w-12 text-slate-600" strokeWidth={1.25} />
      <h2 className="mt-4 text-lg font-semibold text-white">Abonnements</h2>
      <p className="mt-2 text-sm text-slate-400">
        Cette section accueillera la gestion des plans, essais et facturation SaaS.
      </p>
    </div>
  );
}
